// import React from 'react';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import { 
//   FaArrowRight, 
//   FaLaptopCode, 
//   FaMobile, 
//   FaCloud, 
//   FaShieldAlt, 
//   FaChartLine,
//   FaUsers,
//   FaRocket,
//   FaCheckCircle
// } from 'react-icons/fa';
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

// const Home = () => {
//   const services = [
//     {
//       icon: <FaLaptopCode className="text-4xl text-blue-600" />,
//       title: 'Web Development',
//       description: 'Custom web applications built with cutting-edge technologies',
//       link: '/services#web'
//     },
//     {
//       icon: <FaMobile className="text-4xl text-blue-600" />,
//       title: 'Mobile App Development',
//       description: 'Native and cross-platform mobile solutions for iOS and Android',
//       link: '/services#mobile'
//     },
//     {
//       icon: <FaCloud className="text-4xl text-blue-600" />,
//       title: 'Cloud Solutions',
//       description: 'Scalable cloud infrastructure and migration services',
//       link: '/services#cloud'
//     },
//     {
//       icon: <FaShieldAlt className="text-4xl text-blue-600" />,
//       title: 'Cybersecurity',
//       description: 'Comprehensive security audits and protection',
//       link: '/services#security'
//     },
//     {
//       icon: <FaChartLine className="text-4xl text-blue-600" />,
//       title: 'Digital Marketing',
//       description: 'Data-driven marketing strategies for growth',
//       link: '/services#marketing'
//     },
//     {
//       icon: <FaUsers className="text-4xl text-blue-600" />,
//       title: 'IT Consulting',
//       description: 'Expert guidance for your technology decisions',
//       link: '/services#consulting'
//     }
//   ];

//   const stats = [
//     { value: '50+', label: 'Projects Completed', icon: <FaCheckCircle /> },
//     { value: '30+', label: 'Happy Clients', icon: <FaUsers /> },
//     { value: '5+', label: 'Years Experience', icon: <FaRocket /> }
//   ];

//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 640,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Versaimmortal Infotech - Innovative IT Solutions</title>
//         <meta name="description" content="Versaimmortal Infotech provides cutting-edge IT solutions including web development, mobile apps, cloud services, and digital marketing." />
//         <meta name="keywords" content="IT company, web development, mobile apps, cloud services, digital marketing" />
//         <meta property="og:title" content="Versaimmortal Infotech - Innovative IT Solutions" />
//         <meta property="og:description" content="Leading IT company providing innovative technology solutions" />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content="https://versaimmortal.com" />
//         <link rel="canonical" href="https://versaimmortal.com" />
        
//         {/* Schema.org markup for organization */}
//         <script type="application/ld+json">
//           {JSON.stringify({
//             "@context": "https://schema.org",
//             "@type": "Organization",
//             "name": "Versaimmortal Infotech",
//             "url": "https://versaimmortal.com",
//             "logo": "https://versaimmortal.com/logo.png",
//             "sameAs": [
//               "https://www.facebook.com/versaimmortal",
//               "https://www.linkedin.com/company/versaimmortal",
//               "https://twitter.com/versaimmortal"
//             ],
//             "contactPoint": {
//               "@type": "ContactPoint",
//               "telephone": "+1-123-456-7890",
//               "contactType": "customer service",
//               "availableLanguage": ["English"]
//             }
//           })}
//         </script>
//       </Helmet>

//       {/* Hero Section */}
//       <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white overflow-hidden">
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div className="relative container mx-auto px-4 py-24 md:py-32">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//             className="max-w-3xl"
//           >
//             <h1 className="text-4xl md:text-6xl font-bold mb-6">
//               Transforming Ideas into Digital Reality
//             </h1>
//             <p className="text-xl mb-8 text-gray-200">
//               We deliver innovative technology solutions that drive business growth and digital transformation.
//             </p>
//             <div className="flex flex-wrap gap-4">
//               <Link
//                 to="/contact"
//                 className="bg-white text-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 flex items-center gap-2"
//               >
//                 Get Started <FaArrowRight />
//               </Link>
//               <Link
//                 to="/services"
//                 className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition duration-300"
//               >
//                 Our Services
//               </Link>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section className="py-20 bg-gray-50">
//         <div className="container mx-auto px-4">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//             className="text-center mb-12"
//           >
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Our Services
//             </h2>
//             <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//               Comprehensive IT solutions tailored to your business needs
//             </p>
//           </motion.div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {services.map((service, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//                 className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition duration-300"
//                 data-aos="fade-up"
//                 data-aos-delay={index * 100}
//               >
//                 <div className="mb-4">{service.icon}</div>
//                 <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
//                 <p className="text-gray-600 mb-4">{service.description}</p>
//                 <Link
//                   to={service.link}
//                   className="text-blue-600 font-semibold hover:text-blue-800 flex items-center gap-2"
//                 >
//                   Learn More <FaArrowRight className="text-sm" />
//                 </Link>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="py-16 bg-blue-600 text-white">
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {stats.map((stat, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ scale: 0 }}
//                 whileInView={{ scale: 1 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//                 className="text-center"
//               >
//                 <div className="text-5xl mb-4 flex justify-center">
//                   {stat.icon}
//                 </div>
//                 <div className="text-4xl font-bold mb-2">{stat.value}</div>
//                 <div className="text-xl text-blue-100">{stat.label}</div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Testimonials Section */}
//       <section className="py-20 bg-white">
//         <div className="container mx-auto px-4">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//             className="text-center mb-12"
//           >
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               What Our Clients Say
//             </h2>
//             <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//               Don't just take our word for it - hear from our satisfied clients
//             </p>
//           </motion.div>

//           <Slider {...sliderSettings} className="testimonials-slider">
//             {[1, 2, 3, 4, 5, 6].map((item) => (
//               <div key={item} className="px-4">
//                 <div className="bg-gray-50 rounded-xl p-6 shadow-lg">
//                   <div className="flex items-center mb-4">
//                     <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
//                       {String.fromCharCode(64 + item)}
//                     </div>
//                     <div className="ml-4">
//                       <h4 className="font-semibold">Client Name</h4>
//                       <p className="text-gray-600 text-sm">CEO, Company</p>
//                     </div>
//                   </div>
//                   <p className="text-gray-700 italic">
//                     "Versaimmortal Infotech delivered an exceptional product that exceeded our expectations. Their team's expertise and professionalism are outstanding."
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </Slider>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 bg-gray-900 text-white">
//         <div className="container mx-auto px-4 text-center">
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//           >
//             <h2 className="text-3xl md:text-4xl font-bold mb-6">
//               Ready to Start Your Project?
//             </h2>
//             <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
//               Let's discuss how we can help transform your business with technology
//             </p>
//             <Link
//               to="/contact"
//               className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-300 inline-flex items-center gap-2"
//             >
//               Contact Us Today <FaArrowRight />
//             </Link>
//           </motion.div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Home;







import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  FaArrowRight, 
  FaLaptopCode, 
  FaMobile, 
  FaCloud, 
  FaShieldAlt, 
  FaChartLine,
  FaUsers,
  FaRocket,
  FaCheckCircle
} from 'react-icons/fa';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Home = () => {
  const services = [
    {
      icon: <FaLaptopCode className="text-4xl text-blue-600" />,
      title: 'Web Development',
      description: 'Custom web applications built with cutting-edge technologies',
      link: '/services#web'
    },
    {
      icon: <FaMobile className="text-4xl text-blue-600" />,
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile solutions for iOS and Android',
      link: '/services#mobile'
    },
    {
      icon: <FaCloud className="text-4xl text-blue-600" />,
      title: 'Cloud Solutions',
      description: 'Scalable cloud infrastructure and migration services',
      link: '/services#cloud'
    },
    {
      icon: <FaShieldAlt className="text-4xl text-blue-600" />,
      title: 'Cybersecurity',
      description: 'Comprehensive security audits and protection',
      link: '/services#security'
    },
    {
      icon: <FaChartLine className="text-4xl text-blue-600" />,
      title: 'Digital Marketing',
      description: 'Data-driven marketing strategies for growth',
      link: '/services#marketing'
    },
    {
      icon: <FaUsers className="text-4xl text-blue-600" />,
      title: 'IT Consulting',
      description: 'Expert guidance for your technology decisions',
      link: '/services#consulting'
    }
  ];

  const stats = [
    { value: '50+', label: 'Projects Completed', icon: <FaCheckCircle /> },
    { value: '30+', label: 'Happy Clients', icon: <FaUsers /> },
    // { value: '5+', label: 'Years Experience', icon: <FaRocket /> }  // Commented out as requested
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>Versaimmortal Infotech - Innovative IT Solutions</title>
        <meta name="description" content="Versaimmortal Infotech provides cutting-edge IT solutions including web development, mobile apps, cloud services, and digital marketing." />
        <meta name="keywords" content="IT company, web development, mobile apps, cloud services, digital marketing" />
        <meta property="og:title" content="Versaimmortal Infotech - Innovative IT Solutions" />
        <meta property="og:description" content="Leading IT company providing innovative technology solutions" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://versaimmortal.com" />
        <link rel="canonical" href="https://versaimmortal.com" />
        
        {/* Schema.org markup for organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Versaimmortal Infotech",
            "url": "https://versaimmortal.com",
            "logo": "https://versaimmortal.com/logo.png",
            "sameAs": [
              "https://www.facebook.com/versaimmortal",
              "https://www.linkedin.com/company/versaimmortal",
              "https://twitter.com/versaimmortal"
            ],
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+1-123-456-7890",
              "contactType": "customer service",
              "availableLanguage": ["English"]
            }
          })}
        </script>
      </Helmet>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative container mx-auto px-4 py-24 md:py-32">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Transforming Ideas into Digital Reality
            </h1>
            <p className="text-xl mb-8 text-gray-200">
              We deliver innovative technology solutions that drive business growth and digital transformation.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/contact"
                className="bg-white text-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 flex items-center gap-2"
              >
                Get Started <FaArrowRight />
              </Link>
              <Link
                to="/services"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition duration-300"
              >
                Our Services
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Our Services
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Comprehensive IT solutions tailored to your business needs
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition duration-300"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <Link
                  to={service.link}
                  className="text-blue-600 font-semibold hover:text-blue-800 flex items-center gap-2"
                >
                  Learn More <FaArrowRight className="text-sm" />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-center">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center"
              >
                <div className="text-5xl mb-4 flex justify-center">
                  {stat.icon}
                </div>
                <div className="text-4xl font-bold mb-2">{stat.value}</div>
                <div className="text-xl text-blue-100">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section - Commented out as requested */}
      {/*
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What Our Clients Say
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Don't just take our word for it - hear from our satisfied clients
            </p>
          </motion.div>

          <Slider {...sliderSettings} className="testimonials-slider">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div key={item} className="px-4">
                <div className="bg-gray-50 rounded-xl p-6 shadow-lg">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
                      {String.fromCharCode(64 + item)}
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold">Client Name</h4>
                      <p className="text-gray-600 text-sm">CEO, Company</p>
                    </div>
                  </div>
                  <p className="text-gray-700 italic">
                    "Versaimmortal Infotech delivered an exceptional product that exceeded our expectations. Their team's expertise and professionalism are outstanding."
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      */}

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to Start Your Project?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Let's discuss how we can help transform your business with technology
            </p>
            <Link
              to="/contact"
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-300 inline-flex items-center gap-2"
            >
              Contact Us Today <FaArrowRight />
            </Link>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Home;